module.exports = __webpack_public_path__ + "img/gamejam.81723708.gif";